module.exports = __webpack_public_path__ + "static/media/healtheat-mockup.9213f1b9.png";